// Wrapper do React.lazy para sobreviver a deploys: quando o build novo sobe,
// os chunks antigos somem do servidor e o import() de uma rota lazy toma 404
// (ChunkLoadError) na aba que ficou aberta. Em vez de quebrar a tela,
// recarregamos a página — que baixa o index.html novo e resolve.
// O guard em sessionStorage limita a 1 reload por falha, senão um erro
// persistente (ex: rede fora) viraria loop infinito de reload.
import { lazy } from "react";

const CHAVE_RELOAD = "treino_chunk_reload";

export const lazyComReload = (importacao) =>
	lazy(() =>
		importacao()
			.then((modulo) => {
				sessionStorage.removeItem(CHAVE_RELOAD);
				return modulo;
			})
			.catch((erro) => {
				if (!sessionStorage.getItem(CHAVE_RELOAD)) {
					sessionStorage.setItem(CHAVE_RELOAD, "1");
					window.location.reload();
					// segura o Suspense no fallback enquanto a página recarrega
					return new Promise(() => {});
				}
				throw erro;
			})
	);
